﻿
import { enableFormSubmission } from './enable-form';
import { hasRuntimeValidate, hasOptionValidate } from '../../foundation/form/validation';
import { Field } from './field';

export const runtimeFormValidation = () => {

    const Form = function (form) {
        const allFields = [...form.querySelectorAll('input, textarea, select')];
        const optionRuntimeField = allFields.filter(field => hasOptionValidate(field))[0];

        const runtimeValidationFields = allFields.filter(field => hasRuntimeValidate(field))
            .map(field => Field(field));
        
        const getValidateOptions = () => optionRuntimeField.getAttribute('data-runtime-validate') ? 
                optionRuntimeField.getAttribute('data-runtime-validate').split(',') : [];

        const isValidateOption = () => {
            const validateOptions = getValidateOptions();

            return validateOptions.some((val) => optionRuntimeField.options[optionRuntimeField.selectedIndex].text.trim().toLowerCase() === val.trim().toLowerCase());
        };

        const isObject = obj => {
            return (typeof obj === "object" && obj !== null) || typeof obj === "function";
        };

        const setRequired = (field, elementCondition) => {
            const isRequired = isObject(elementCondition) ? elementCondition() : elementCondition;

            if (isRequired) {
                field.setRequired();
            }
            else {
                field.removeRequired();
            }    
        }

        const setFormValidation = () => {
            runtimeValidationFields.forEach(field => { 
                setRequired(field, isValidateOption);
            });
        }

        const bindEvents = () => {
            
            const handler = () => {
                setFormValidation();

                enableFormSubmission().init(form);
            };

            optionRuntimeField.addEventListener('change', handler);
        };
        
        return {
            init() {
                bindEvents();

                setFormValidation();
                enableFormSubmission().init(form);
            }
        };
    };

    const init = component => {
        const form = new Form(component);
        form.init();
    };

    return {
        init: init,
        selector: '.js-form.js-form-runtime-validation'
    };
};